import React, { useState } from 'react';
import { Card, Input, Button, Table, Tag, message, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';

const { TextArea } = Input;
const { Title } = Typography;

const API_BASE = 'https://wecom.wzxn.top';

const STATUS_MAP = {
  1: { text: '已激活', color: 'green' },
  2: { text: '未激活', color: 'orange' },
  3: { text: '已过期', color: 'red' },
  4: { text: '已禁用', color: 'default' },
};

function formatTime(ts) {
  if (!ts || ts === 0) return '—';
  return new Date(ts * 1000).toLocaleString('zh-CN');
}

const LicenseQuery = () => {
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const handleQuery = async () => {
    const trimmed = input.trim();
    if (!trimmed) {
      message.warning('请输入 License 码');
      return;
    }
    const codes = trimmed
      .split(/[\n,]/)
      .map((s) => s.trim())
      .filter(Boolean)
      .join(',');
    if (!codes) {
      message.warning('请输入 License 码');
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/license/query`, {
        params: { licenses: codes, env: 'formal' },
      });
      if (res.data.code === 0) {
        setData(res.data.data?.list || []);
        message.success('查询完成');
      } else {
        message.error(res.data.message || '查询失败');
      }
    } catch (err) {
      message.error(
        '请求失败: ' + (err.response?.data?.message || err.message)
      );
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { title: 'License', dataIndex: 'license', key: 'license', width: 180, onCell: () => ({ style: { whiteSpace: 'nowrap' } }) },
    { title: '产品名称', dataIndex: 'productName', key: 'productName', onCell: () => ({ style: { whiteSpace: 'nowrap' } }) },
    { title: '产品ID', dataIndex: 'productId', key: 'productId', onCell: () => ({ style: { whiteSpace: 'nowrap' } }) },
    { title: '企业名称', dataIndex: 'companyName', key: 'companyName', onCell: () => ({ style: { whiteSpace: 'nowrap' } }) },
    { title: '企业ID', dataIndex: 'companyId', key: 'companyId', onCell: () => ({ style: { whiteSpace: 'nowrap' } }) },
    {
      title: '激活状态', dataIndex: 'activeStatus', key: 'activeStatus', width: 100,
      render: (v) => {
        const s = STATUS_MAP[v] || { text: v, color: 'default' };
        return <Tag color={s.color}>{s.text}</Tag>;
      },
    },
    { title: '激活时间', dataIndex: 'activeTime', key: 'activeTime', width: 170, render: formatTime },
    { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', width: 170, render: formatTime },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={4}>！！生产环境—License信息查询工具</Title>
      <Card style={{ marginBottom: 24 }}>
        <TextArea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="请输入 License 码，支持换行或英文逗号分隔"
          rows={6}
          style={{ marginBottom: 12 }}
        />
        <Button type="primary" icon={<SearchOutlined />} onClick={handleQuery} loading={loading}>
          查询
        </Button>
      </Card>

      {data.length > 0 && (
        <Table
          dataSource={data}
          columns={columns}
          rowKey="license"
          bordered
          size="middle"
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
      )}
    </div>
  );
};

export default LicenseQuery;
